// extracted by mini-css-extract-plugin
export default {"productCarousel":"xZ-z"};